/* ClickToExpand.tsx
 * This displays a
 *   that uses less white-space
 *   It will not collide with the <BatchActions> menu.
 * When using directly (and not as part of BaseTable), the parent
 *   <div> MUST have `position: relative;` for correct styling.
 */
import classnames from "classnames";
import React from "react";
import FontAwesome from "react-fontawesome";

const styles = require("./CollapseExpandToggle.module.scss");

interface ClickToCollapseProps {
  isCollapsed: boolean;
  collapseToggleFunc: Function;
}
interface ClickToExpandProps {
  expandText?: string;
  collapseToggleFunc: Function;
  alignToEnd?: boolean;
}

export const ClickToCollapse: React.FC<ClickToCollapseProps> = ({
  isCollapsed,
  collapseToggleFunc,
}) => {
  return (
    <span
      onClick={e => {
        e.stopPropagation();
        collapseToggleFunc();
      }}
      className={styles.collapsedNoteHover}
    >
      {!isCollapsed && (
        <>
          <span className={styles.collapsedNoteIcon}>
            <FontAwesome name="minus-square" />
          </span>
          <span className={styles.collapsedNoteText}>&nbsp;Collapse</span>
        </>
      )}
      {isCollapsed && (
        <>
          <span className={styles.collapsedNoteIcon}>
            <FontAwesome name="plus-square" />
          </span>
          <span className={styles.collapsedNoteText}>&nbsp;Expand</span>
        </>
      )}
    </span>
  );
};

export const ClickToExpand: React.FC<ClickToExpandProps> = ({
  expandText = "Click to expand.",
  collapseToggleFunc,
  alignToEnd = false,
}) => {
  return (
    <div
      onClick={() => collapseToggleFunc()}
      className={classnames(styles.tableCollapsedFiller, alignToEnd && styles.alignToEnd)}
    >
      {expandText}
    </div>
  );
};

const ClickTo = {
  Collapse: ClickToCollapse,
  Expand: ClickToExpand,
};

export default ClickTo;
